import { render, staticRenderFns } from "./lineup_horizontalPGA.vue?vue&type=template&id=2f1452b1&scoped=true"
import script from "./lineup_horizontalPGA.vue?vue&type=script&lang=js"
export * from "./lineup_horizontalPGA.vue?vue&type=script&lang=js"
import style0 from "./lineup_horizontalPGA.vue?vue&type=style&index=0&id=2f1452b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1452b1",
  null
  
)

export default component.exports